import { render, staticRenderFns } from "./course-guides-holes.vue?vue&type=template&id=7f038f52"
import script from "./course-guides-holes.vue?vue&type=script&lang=js"
export * from "./course-guides-holes.vue?vue&type=script&lang=js"
import style0 from "./course-guides-holes.vue?vue&type=style&index=0&id=7f038f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports